import { createActions, createReducer } from "reduxsauce"
import { call, put, takeEvery } from "redux-saga/effects"
import { post } from "api"
import { secondsToTimePhrase } from "helpers/dates"
import { TooManyRequestsError } from "api/errors"

export const { Types, Creators } = createActions({
  resetPassword: ["email"],
  setEmailSent: [],
  setErrorMessage: ["error"],
  clearError: [],
  reset: [],
}, {
  prefix: "ompnt/modules/forgotPassword/",
})

const INITIAL_STATE = {
  emailSent: null,
  error: null,
}

function handleSetEmailSent(state) {
  return { ...state, emailSent: true }
}

function handleSetErrorMessage(state, { error }) {
  return { ...state, error }
}

function handleClearError(state) {
  return { ...state, error: null }
}

function handleReset() {
  return { ...INITIAL_STATE }
}

export const HANDLERS = {
  [Types.SET_EMAIL_SENT]: handleSetEmailSent,
  [Types.SET_ERROR_MESSAGE]: handleSetErrorMessage,
  [Types.CLEAR_ERROR]: handleClearError,
  [Types.RESET]: handleReset,
}

export default createReducer(INITIAL_STATE, HANDLERS)

function* resetPassword({ email }) {
  try {
    yield call(post, "/api/users/forgot-password", { email }, true)
    yield put(Creators.setEmailSent(true))
  } catch (err) {
    let error = "An unexpected error occured."

    if (err instanceof TooManyRequestsError) {
      const timePhrase = secondsToTimePhrase(err.retryAfter)
      error = `You've reached the maximum number of reset password attempts. Try again ${timePhrase}.`
    }

    yield put(Creators.setErrorMessage(error))
  }
}

export function* saga() {
  yield takeEvery(Types.RESET_PASSWORD, resetPassword)
}
